import { render, staticRenderFns } from "./ListCompetition.vue?vue&type=template&id=5405265a"
import script from "./ListCompetition.vue?vue&type=script&lang=js"
export * from "./ListCompetition.vue?vue&type=script&lang=js"
import style0 from "./ListCompetition.vue?vue&type=style&index=0&id=5405265a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports